import { Site } from "api/types/site";
import { CONST } from "models/constants";
import LabeledField from "providers/labeledField";
import { useState } from "react";
import { MdEditDocument } from "react-icons/md";
import { shallowEqual, useSelector } from "react-redux";
import { rateStructuresList } from "store/appSelectors";
import GenericCard from "widgets/cards/generic";
import SiteConfigurationDialog from "widgets/dialogs/siteConfoguration";
import CircleButton from "widgets/controls/buttons/circle-button";
import { useTranslation } from "react-i18next";

interface GeneralProps {
  site?: Site;
  onUpdate?: () => void;
}

const Configuration: React.FC<GeneralProps> = ({ site, onUpdate }) => {
  const { t } = useTranslation();
  const ratesStructureList = useSelector(rateStructuresList, shallowEqual);

  const [showSiteConfig, setShowSiteConfig] = useState(false);

  const handleClose = (refresh: boolean) => {
    setShowSiteConfig(false);
    if (refresh) {
      onUpdate();
    }
  };

  const getFriendlyName = (id: string) => {
    const found = ratesStructureList.find((r) => r.id === id);
    return found?.name || t("form.input.site.rate.structure");
  };

  return (
    <>
      {showSiteConfig && (
        <SiteConfigurationDialog
          site={site}
          isOpen={showSiteConfig}
          onClose={() => {
            handleClose(false);
          }}
          onSuccess={() => {
            handleClose(true);
          }}
        />
      )}

      <GenericCard
        title={t("device.configuration")}
        bgColor="500"
        extraTitle="text-white heading-md"
        topRight={
          <div className="-mt-2 flex">
            <CircleButton
              icon={MdEditDocument}
              size="md"
              onClick={() => {
                setShowSiteConfig(true);
              }}
              variant="ghost"
              color="white"
              permissionRole={CONST.ROLE_OWNER}
              tooltip={t("tooltip.edit.configuration")}
              tooltipPlacement="bottom"
            />
          </div>
        }
      >
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("form.input.site.rate.structure")}
            id={"rate-structure"}
          >
            <div className="text-txt-lg text-white">
              {getFriendlyName(site?.rateStructureId)}
            </div>
          </LabeledField>
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("form.input.site.collector")}
            id={"site-collector"}
          >
            <div className="text-txt-lg text-white">
              {site?.collector || t("form.input.site.collector")}
            </div>
          </LabeledField>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("form.input.billing.period")}
            id={"site-billing-period"}
          >
            <div className="text-txt-lg text-white">
              {site?.billingPeriod || t("form.input.billing.period")}
            </div>
          </LabeledField>
          <LabeledField
            className="text-txt-xs"
            textColor="white"
            label={t("form.input.site.service.level")}
            id={"service-level"}
          >
            <div className="text-txt-lg text-white">
              {site?.serviceLevel || t("form.input.site.service.level")}
            </div>
          </LabeledField>
        </div>
      </GenericCard>
    </>
  );
};

export default Configuration;
